"use client";

import { useEffect } from "react";
import { datadogRum } from "@datadog/browser-rum";
import ErrorPage from "@/components/layout/statusPages/ErrorPage";

interface Props {
  error: Error & { digest?: string };
}

export default function Error({ error }: Props) {
  useEffect(() => {
    datadogRum.addError(error, {
      source: "next-error-boundary",
      componentStack: error.stack,
    });
  }, [error]);

  return <ErrorPage />;
}
